module.exports = __webpack_public_path__ + "img/2.abddffb0.png";